import React from 'react';

export interface SelectFieldOption {
  id: string;
  label: string;
}

export interface SelectFieldProps {
  id?: string;
  value: string;
  onChange: (value: string) => void;
  options: SelectFieldOption[];
  placeholder: string;
  error?: string;
}

export const SelectField = ({ id, value, onChange, options, placeholder, error }: SelectFieldProps) => {
  return (
    <div className="flex flex-column" style={{ gap: '4px' }}>
      <select
        id={id}
        className={`f-14 ${error ? ' red' : ''}`}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{
          width: 240,
          padding: '8px 12px',
          borderRadius: 4,
          border: '1px solid #ddd',
        }}
      >
        <option value="">None</option>
        {options.map((option) => (
          <option key={option.id} value={option.id}>
            {option.label}
          </option>
        ))}
      </select>
      {error && <span className="red f-12 mt-2">{error}</span>}
    </div>
  );
};
